import { render, staticRenderFns } from "./Finances.vue?vue&type=template&id=7665993c&"
import script from "./Finances.vue?vue&type=script&lang=js&"
export * from "./Finances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports